<app-error-code
  code="404"
  [title]="'Page not found!'"
  [message]="'This is not the web page you are looking for.'"
></app-error-code>
